/**
 * ActionSource テーブルのレコードをドメインの ActionSource 型へ変換する。
 */
import { blobToHex } from '@pkg/basic'
import {
  actionSourceCardanoSchema,
  actionSourcePolkadotSchema,
  actionSourceSolanaSchema,
  actionSourceXrplSchema,
} from '../querySchema'
import type { actionSourceTable } from '../schema'
import type { ActionSource, ActionSourceEvm } from '../types'

/**
 * DB から取得した ActionSource レコードを ActionSource に変換する。
 */
export const parseToActionSource = (
  actionSource: typeof actionSourceTable.$inferSelect,
): ActionSource => {
  switch (actionSource.type) {
    case 'xrpl': {
      return actionSourceXrplSchema.parse(actionSource)
    }
    case 'cardano': {
      return actionSourceCardanoSchema.parse(actionSource)
    }
    case 'evm': {
      if (actionSource.evmChainId === null) {
        throw new Error('evmChainId is null')
      }
      if (actionSource.evmHash === null) {
        throw new Error('evmHash is null')
      }
      return {
        id: actionSource.id,
        type: 'evm',
        evmChainId: actionSource.evmChainId,
        evmHash: blobToHex(actionSource.evmHash),
        evmFrom:
          actionSource.evmFrom === null
            ? undefined
            : blobToHex(actionSource.evmFrom),
        evmTo:
          actionSource.evmTo === null
            ? undefined
            : blobToHex(actionSource.evmTo),
        evmStatus: actionSource.evmStatus ?? 'success',
        evmFunctionId:
          actionSource.evmFunctionId === null
            ? undefined
            : blobToHex(actionSource.evmFunctionId),
        evmFunctionName: actionSource.evmFunctionName ?? undefined,
        tokenTransferCount: actionSource.tokenTransferCount,
        tokenTransferCountVersion: actionSource.tokenTransferCountVersion,
      } satisfies ActionSourceEvm
    }
    case 'polkadot': {
      return actionSourcePolkadotSchema.parse(actionSource)
    }
    case 'solana': {
      return actionSourceSolanaSchema.parse(actionSource)
    }
    case 'other': {
      return {
        id: actionSource.id,
        type: 'other',
      }
    }
    default: {
      throw new Error(`Unknown value: ${actionSource.type satisfies never}`)
    }
  }
}
